import styled from '@emotion/styled'
import { breakpoint } from '../../../__styling/style-functions'
import { tokens } from '@news-mono/design-tokens'
import { getComponentTheme } from '../../../__styling'
import { calcRem } from '../../../__styling/style-functions/calc-rem'

export const AccordionContainer = styled.div(({ theme }) => ({
    margin:
        theme.kind === 'sevennews'
            ? calcRem(0, theme.margins.sm, 24, theme.margins.sm)
            : undefined,

    [breakpoint('sm')]: {
        margin: theme.kind === 'sevennews' ? calcRem(0, 0, 24, 0) : undefined,
    },

    [breakpoint('lg')]: {
        display: 'none',
    },
}))

export const Divider = styled.div(({ theme }) => {
    const color =
        theme.kind === 'sevennews'
            ? tokens.sevennews.colors.palette.alto
            : getComponentTheme(theme, 'taglinkNav').divider.color

    const margin =
        theme.kind === 'sevennews'
            ? calcRem(0, 0, 24, 0)
            : calcRem(0, 24, 24, 24)

    return {
        margin,
        display: 'flex',
        height: calcRem(1),
        background: color,
    }
})
